module.exports = __webpack_public_path__ + "media/images/emblems/Riedholz-blason-8130e243b8751db94ba405d2bb361105.png";